import { useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';

export const GET_SUPPORT_REQUESTS = gql`
  query ($filter: SupportFilterInput, $queryOptions: QueryOptionsInput) {
    getSupportRequests(filter: $filter, queryOptions: $queryOptions) {
      collection {
        _id
        company {
          name
        }
        status
        expiredAt
        email
        phoneNumber
        details
      }
      totalCount
    }
  }
`;

export const useGetSupportRequests = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const companyId = useGetCurrentCompanyId();
  const { member } = useGetCurrentMemberAccount();

  const pageSize = 12;
  const { data, loading } = useQuery(GET_SUPPORT_REQUESTS, {
    variables: {
      filter: { companyId, memberId: member._id },
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const { collection = [], totalCount = 0 } = data?.getSupportRequests || {};

  return {
    loading,
    supportRequests: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setCurrentPage(page),
    },
  };
};
